import React, { memo } from "react";
import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';

const BlankField = (props)=>{
  const  {
    item,
    className,
    validationForms
  } = props;
  const attr = formFieldsAttributes({...item,className:className},validationForms,e => {});
  return(
    <FormBlocks {...props} isLabel={false} attr={attr}></FormBlocks>
  )
};


BlankField.defaultProps = {
  className: "form-control"
}
const isDiffProps = (prevProps,nextProps)=>{
  if(prevProps.item===nextProps.item){
    return true;
  }
}

export default memo(BlankField,isDiffProps);
